import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { LogOut, Menu } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { useSidebarContext } from "@/components/ui/sidebar";
import { useIsMobile } from "@/hooks/use-mobile";
import { LanguageSwitcher } from "./LanguageSwitcher";
import { CurrencySwitcher } from "./CurrencySwitcher";
import { NotificationBell } from "@/components/notifications/NotificationBell";
import { AnnouncementTicker } from "./AnnouncementTicker";
import { NotificationPermissionPrompt } from "@/components/notifications/NotificationPermissionPrompt";

export const Navbar = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const { setIsCollapsed } = useSidebarContext();
  const isMobile = useIsMobile();

  const handleSignOut = async () => {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;

      navigate("/login");
      toast({
        title: "Success",
        description: "You have been signed out successfully",
      });
    } catch (error) {
      console.error("Error signing out:", error);
      toast({
        variant: "destructive",
        title: "Error",
        description: "Failed to sign out. Please try again.",
      });
    }
  };

  return (
    <>
      <NotificationPermissionPrompt />
      <nav className="border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 sticky top-0 z-50">
      <div className="flex h-14 md:h-16 items-center justify-between px-3 md:px-6 gap-2">
        {isMobile && (
          <Button 
            variant="ghost" 
            size="icon"
            onClick={() => setIsCollapsed(true)}
            className="touch-manipulation"
          >
            <Menu className="h-5 w-5" />
          </Button>
        )}
        <div className="flex-1 min-w-0">
          <AnnouncementTicker />
        </div>
        <div className="flex items-center gap-1 md:gap-2">
          {!isMobile && (
            <>
              <LanguageSwitcher />
              <CurrencySwitcher />
            </>
          )}
          <NotificationBell />
          <Button 
            variant="ghost"
            size="icon"
            onClick={handleSignOut}
            className="hover:bg-destructive/10 touch-manipulation"
          >
            <LogOut className="h-5 w-5 text-destructive" />
            <span className="sr-only">Sign out</span>
          </Button>
        </div>
      </div>
    </nav>
    </>
  );
};